import React from "react";
import { DialogActions } from "@material-ui/core";
import Button from "../TabletButton";
import { makeStyles } from "@material-ui/core/styles";
import ButtonWithSpinner from "../ButtonWithSpinner";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: theme.spacing(2, 3, 3),
  },
  saveButton: {
    ...theme.neoUI?.buttons?.action?.root,
  },
  cancelButton: {
    ...theme.neoUI.buttons.action.cancel.root,
  }
}));

export const DialogActionButtons = ({
  onCancel,
  onSave,
  cancelLabel = "Cancelar",
  saveLabel = "Salvar",
  tabletSubject = "node",
  cancelColor = "secondary",
  saveColor = "primary",
  loading = false,
  disabled = false,
  saveType = "button",
  showSpinner = false,
  saveStartIcon = null,
  cancelStartIcon = null,
  disableCancelOnLoading = true,
  cancelDisabled,
  height,
  leftContent = null,
}) => {
  const classes = useStyles();

  return (
    <DialogActions className={classes.dialogActions}>
      {leftContent ? <div style={{ marginRight: "auto" }}>{leftContent}</div> : null}
      <Button
        onClick={onCancel}
        variant="outlined"
        color={cancelColor || undefined}
        className={classes.cancelButton}
        style={height ? { height, minHeight: height } : {}}
        startIcon={cancelStartIcon}
        disabled={cancelDisabled ?? (disableCancelOnLoading ? loading || disabled : disabled)}
      >
        {cancelLabel}
      </Button>
      <ButtonWithSpinner
        tabletSubject={tabletSubject}
        loading={loading}
        onClick={onSave}
        variant="contained"
        disabled={disabled}
        type={saveType}
        color={saveColor || undefined}
        className={classes.saveButton}
        style={height ? { height, minHeight: height } : {}}
        startIcon={saveStartIcon}
      >
        {saveLabel}
      </ButtonWithSpinner>
    </DialogActions>
  );
};

export default DialogActionButtons;
